<template>
  <div>
    <my-header></my-header>
    <div class="pd20">
      <div class="sale-market">
        <sale-market-head></sale-market-head>
        <loading
          v-if="allProducts == null"
          class="mt10 text-center"
          :text="'Please wait'|translate"
        ></loading>
        <div class="list-products" v-if="allProducts!= null">
          <div class="row">
            <div
              class="col-md-4 col-xs-12 col-sm-6"
              v-for="(product) in allProducts"
              :key="product.id"
            >
              <div class="media mb30">
                <div class="media-left">
                  <img class="thumb" :src="product.feature_image_path" />
                </div>
                <div class="media-body">
                  <h4 class="media-heading mb5">{{product.name}}</h4>
                  <ul class="my-list">
                    <li v-for="(variant) in product.variants" :key="variant.id">
                      <router-link
                        :to="{ name: 'SaleMarketVarriant', params: { product_id: variant.product_id, varriant_id: variant.id, varriant_name: variant.name }}"
                        class="text-size-normal"
                      ><i class="far fa-hand-point-right"></i> {{variant.name}}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "SaleMarket",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead,
  },
  data() {
    let data = {
      allProducts: null,
    };

    return data;
  },

  methods: {
    getAllProducts() {
      Utils.getAllProducts(this, {}).then((data) => {
        this.allProducts = data;
      });
    },
  },
  mounted() {
    this.getAllProducts();
  },
  beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarket.vue